import React from "react";
import { motion } from 'framer-motion';
// import Button from "../Button/button";
import { useNavigate } from "react-router-dom";
import NewButton from "../../components/Button/newbutton";
const BreakfastHero = () => {
    const navigate = useNavigate();
    
    return (
        <><div className="text-[#FD3E31] mt-[2rem] md:mt-0 font-benditos text-[5.5rem] md:text-[10rem] uppercase">
            <motion.p
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: .5, delay: .2 }}
                className="drop-shadow-[4px_4px_0px_#FFB91D]">
                BREAKFAST</motion.p>
        </div><div className="font-summer text-[4rem] md:text-[8rem] text-[#47b9c3]">
                <motion.p
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: .5, delay: .4 }}
                    className="drop-shadow-[4px_4px_0px_rgba(0,0,0)]">
                    MENU</motion.p>
            </div><div className="font-benditos text-[#dbe7e8] text-center text-[3rem] md:text-[5rem]">
                <motion.p
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: .5, delay: .6 }}>
                    
                    <NewButton onClick={() => navigate("/order")}>
                        Order Now
                    </NewButton>
                </motion.p>
            </div></>
    )
};

export default BreakfastHero;